module.exports = __webpack_public_path__ + "media/packs/fonts/UtopiaStd-BoldIt-a5ce446857476cd82fe58057e5fbeeb8.woff2";